<template>
    <q-page class="flex flex-center">
    <div v-if="message" style="margin-bottom: 20px;">
      <q-alert
        color="blue-4" icon="info" enter="fadeIn" leave="fadeOut" appear dismissible
      >
        <b>Logged out: </b> {{ message }}
      </q-alert>
    </div>
    <form @submit.prevent="handleResetPasswordForm">
      <q-card class="mdi-card relative-position">
        <q-card-title class="bg-secondary text-white">
          Reset Password
        </q-card-title>
        <q-card-separator />
        <q-card-main class="q-pa-md">
          <q-field
            icon="mail"
            label="Email"
            orientation="vertical"
            helper="please type in your email address to reset your password"
          >
            <q-input v-model="email" type="email" autofocus />
          </q-field>
          <br>
          <q-field
            label="Reset Code"
            icon="code"
            orientation="vertical"
            helper="The token from your email"
            v-if="!resetToken"
          >
            <q-input v-model="resetToken" />
          </q-field>
          <br>
          <q-field
            icon="lock"
            label="New Password"
            orientation="vertical"
            helper="provide a new password"
          >
            <q-input v-model="password" type="password" />
          </q-field>
          <br>
          <q-field
            orientation="vertical"
            label="Confirm New Password"
            :icon="password && passwordConfirmation === password ? 'check' : 'lock'"
          >
            <q-input v-model="passwordConfirmation" type="password" />
          </q-field>

          <div v-if="error" class="q-ma-lg q-pa-lg">
            <q-alert
              color="negative" icon="error" enter="fadeIn" leave="fadeOut" appear dismissible
            >
              {{ error }}
            </q-alert>
          </div>

        </q-card-main>
        <q-card-actions>
          <q-btn
            v-model="loading"
            loader
            large
            color="primary"
            icon="lock"
            class="full-width no-shadow"
            type="submit"
            label="Reset Password"
            :disabled="!canSubmit || loading"
          >
              <span slot="loading">
                <q-spinner class="on-left" />
                Resetting ...
              </span>
          </q-btn>
        </q-card-actions>
        <q-inner-loading :visible="loading"></q-inner-loading>
      </q-card>
    </form>
  </q-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      error: null,
      message: null
    }
  },
  computed: {
    ...mapGetters('auth', ['roles', 'dashboards', 'anyRole']),
    ...mapState('auth', ['login']),
    canSubmit () {
      return this.resetToken && this.password && this.passwordConfirmation && this.email
    },
    requiresEmail () {
      return this.login.requiresEmail
    },
    email: {
      get () {
        return this.login.email
      },
      set (value) {
        this.$store.commit('auth/SET_LOGIN_KEY', {
          key: 'email',
          value
        })
      }
    },
    resetToken: {
      get () {
        return this.login.resetToken
      },
      set (value) {
        this.$store.commit('auth/SET_LOGIN_KEY', {
          key: 'resetToken',
          value
        })
      }
    },
    passwordConfirmation: {
      get () {
        return this.login.passwordConfirmation
      },
      set (value) {
        this.$store.commit('auth/SET_LOGIN_KEY', {
          key: 'passwordConfirmation',
          value
        })
      }
    },
    password: {
      get () {
        return this.login.password
      },
      set (value) {
        this.$store.commit('auth/SET_LOGIN_KEY', {
          key: 'password',
          value
        })
      }
    }
  },
  methods: {
    ...mapActions('auth', ['loginUser', 'resetPassword']),
    async handleResetPasswordForm () {
      if (this.canSubmit && !this.loading) {
        this.error = null
        this.message = null
        this.$set(this, 'loading', true)
        try {
          await this.resetPassword({
            client: this.$axios,
            resetToken: this.resetToken,
            email: this.email,
            passwordConfirmation: this.passwordConfirmation,
            password: this.password,
            config: {
              headers: {}
            }
          })
          this.$router.push('/auth/login')
        } catch (error) {
          clearInterval(window.waitForMutation)
          this.loading = false
          this.error = 'Could not reset your password.'
        }
      }
    }
  },
  created () {
    if (this.$route.query.token) {
      this.$store.commit('auth/SET_LOGIN_KEY', {
        key: 'resetToken',
        value: this.$route.query.token
      })
    }
    if (this.$route.query.email) {
      this.$store.commit('auth/SET_LOGIN_KEY', {
        key: 'email',
        value: this.$route.query.email
      })
    }
  }
}
</script>
